import { useEffect, useState } from "react";
import { Coins, TrendingUp, Info } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { api } from "@/lib/api";

export default function GoldPriceWidget() {
  const [goldData, setGoldData] = useState({
    formatted_sell: "Rp 1.485.000",
    formatted_buyback: "Rp 1.334.000",
    change_pct: 0.45,
    is_up: true,
    date: new Date().toLocaleDateString("id-ID", { day: "numeric", month: "short", year: "numeric" }),
    tips: "Membeli emas secara bertahap sejak jauh hari membantu menjaga nilai tabungan mas kawin dari inflasi.",
  });

  useEffect(() => {
    let unmounted = false;
    api.get("/gold-price")
      .then((res) => {
        if (!unmounted && res?.data) {
          setGoldData(res.data);
        }
      })
      .catch(() => {
        // Fallback default dipasang di state awal
      });
    return () => {
      unmounted = true;
    };
  }, []);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          data-testid="gold-price-widget-btn"
          className="inline-flex items-center gap-1.5 md:gap-2 rounded-full border border-amber-500/30 bg-amber-500/10 hover:bg-amber-500/15 px-2.5 md:px-3.5 py-1.5 text-xs font-medium text-amber-700 dark:text-amber-300 transition-all duration-150 cursor-pointer shadow-sm select-none"
        >
          <div className="p-1 rounded-full bg-amber-500/20 text-amber-600 dark:text-amber-400 shrink-0">
            <Coins className="h-3.5 w-3.5" />
          </div>
          <div className="flex items-center gap-1.5 whitespace-nowrap">
            <span className="hidden sm:inline font-semibold">Emas:</span>
            <span className="font-bold">{goldData.formatted_sell}</span>
            <span className="inline-flex items-center gap-0.5 text-[10px] px-1.5 py-0.5 rounded-full bg-emerald-500/15 text-emerald-600 dark:text-emerald-400 font-semibold">
              <TrendingUp className="h-3 w-3" />
              +{goldData.change_pct}%
            </span>
          </div>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80 p-4 rounded-2xl shadow-xl border border-border bg-card/95 backdrop-blur-xl">
        <div className="flex items-center justify-between pb-3 border-b border-border/60">
          <div className="flex items-center gap-2">
            <div className="p-2 rounded-xl bg-amber-500/15 text-amber-600 dark:text-amber-400">
              <Coins className="h-4 w-4" />
            </div>
            <div>
              <h4 className="text-sm font-semibold leading-none">Harga Emas Hari Ini</h4>
              <p className="text-[11px] text-muted-foreground mt-0.5">Antam 1 gram ({goldData.date})</p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-2 my-3">
          <div className="p-2.5 rounded-xl bg-amber-500/5 border border-amber-500/15">
            <span className="text-[11px] text-muted-foreground block">Harga Beli</span>
            <span className="text-sm font-bold text-amber-700 dark:text-amber-300">{goldData.formatted_sell}</span>
          </div>
          <div className="p-2.5 rounded-xl bg-muted/40 border border-border/60">
            <span className="text-[11px] text-muted-foreground block">Harga Buyback</span>
            <span className="text-sm font-bold">{goldData.formatted_buyback}</span>
          </div>
        </div>

        <div className="flex items-start gap-2 p-2.5 rounded-xl bg-primary/5 border border-primary/15 text-[11px] leading-relaxed text-muted-foreground">
          <Info className="h-4 w-4 text-primary shrink-0 mt-0.5" />
          <span>{goldData.tips}</span>
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
